import { useTranslation } from "react-i18next";

export default function StatsPanel({ stats, compact }) {
  const { t } = useTranslation();
  if (!stats) return null;

  if (compact) {
    return (
      <div data-testid="stats-panel">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-2">{t("stats.title")}</p>
        <div className="grid grid-cols-2 gap-1.5">
          <StatCard value={stats.total} label={t("stats.total")} bg="bg-gray-50" border="border-gray-200" color="text-gray-900" small />
          <StatCard value={stats.active} label={t("stats.active")} bg="bg-red-50" border="border-red-200" color="text-red-600" small />
          <StatCard value={stats.resolved} label={t("stats.resolved")} bg="bg-green-50" border="border-green-200" color="text-green-600" small />
          <StatCard value={stats.by_type?.security || 0} label={t("stats.security")} bg="bg-gray-50" border="border-gray-200" color="text-gray-900" labelColor="text-red-500" small />
        </div>
      </div>
    );
  }

  return (
    <div className="mt-5" data-testid="stats-panel">
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-3">{t("stats.title")}</p>
      <div className="grid grid-cols-2 gap-2">
        <StatCard value={stats.total} label={t("stats.total")} bg="bg-gray-50" border="border-gray-200" color="text-gray-900" />
        <StatCard value={stats.active} label={t("stats.active")} bg="bg-red-50" border="border-red-200" color="text-red-600" />
        <StatCard value={stats.resolved} label={t("stats.resolved")} bg="bg-green-50" border="border-green-200" color="text-green-600" />
        <StatCard value={stats.by_type?.security || 0} label={t("stats.security")} bg="bg-gray-50" border="border-gray-200" color="text-gray-900" labelColor="text-red-500" />
      </div>
    </div>
  );
}

function StatCard({ value, label, bg, border, color, labelColor = "text-gray-500", small }) {
  return (
    <div className={`${bg} ${small ? "p-1.5" : "p-2.5"} border ${border} rounded-sm`}>
      <p className={`${small ? "text-base" : "text-xl"} font-black font-heading ${color}`}>{value}</p>
      <p className={`text-[10px] uppercase tracking-widest font-bold ${labelColor}`}>{label}</p>
    </div>
  );
}
